<template lang="pug">
    div
        v-app-bar(app clipped-right flat height="50" color="grey darken-3" dark)
            v-app-bar-nav-icon(@click="drawer = !drawer")
            v-toolbar-title {{ general.currentViewName }}

        v-navigation-drawer.grey.darken-4(v-model='drawer' app='' dark)
            v-sheet(color='grey darken-4' dark='' width='100%')
                v-list-item(two-line='')
                    v-list-item-avatar(size='60' rounded='')
                        img(src='@/assets/logo_short.png')
                    v-list-item-content
                        v-list-item-title HTIF.ai
                        v-list-item-subtitle Кабинет
                client-indicators
        v-main
            router-view
</template>
<script>
    import {mapGetters, mapState} from 'vuex'
    // import ManagerDrawerItems from '@/components/manager/DrawerItems.vue'
    import clientNavigationLinks from '@/sidebars/clientSidebar'
    import managerNavigationLinks from '@/sidebars/managerSidebar'
    import ClientIndicators from "@/components/ClientIndicators";
    import DealsWidget from "@/components/DealsWidget";
    import {LOGOUT} from '@/store/types'

    export default {
        name: 'App',
        components: {
          'client-indicators': ClientIndicators,
            'deals-tape-widget': DealsWidget
        },
        computed: {
            ...mapGetters([
                'isAuthenticated'
            ]),
            ...mapState([
                'auth',
                'general'
            ]),
            username () {
                return this.auth.user.username
            },
            userGroups () {
                return this.auth.user.groups
            },
            isAdmin () {
                return this.userGroups.findIndex(function (element) {
                    return element.name === 'manager'
                }) >= 0
            },
            navLinks () {
                return this.isAdmin ? managerNavigationLinks : clientNavigationLinks
            },
        },
        data: () => ({
            drawer: true,
            drawer_client_info: null,
            clipped: true,
            fixed: false,
            drawerWidth: 300,
            right: true,
            rightDrawer: false,
            title: 'HTIF Account',
        }),
        methods: {
            login () {
                console.log('Logged In')
            },
            logout () {
                this.$store.dispatch(LOGOUT)
            },
        },
        mounted () {
            this.$store.dispatch('inspectToken')
            let display_drawers = (this.$vuetify.breakpoint.lg || this.$vuetify.breakpoint.xl)
            console.log(display_drawers)
            this.drawer_client_info = display_drawers
            this.$store.dispatch('getSecuritiesSectors')
        },
        updated () {
            this.$store.dispatch('inspectToken')
        }
    }
</script>
<style scoped>
    h1, h2 {
        font-weight: normal;
    }

    ul {
        list-style-type: none;
        padding: 0;
    }

    li {
        display: inline-block;
        margin: 0 10px;
    }

    a {
        color: #42b983;
    }

    /deep/ .v-toolbar--clipped{
        z-index: 15;
    }



</style>
